import React from "react";
import {Col, Typography, Tag} from "antd";
import "../contentcard.css";
import {
  colorMapping,
  dateFormat,
} from "../../../commonFuntions/CommonUtilFunctions";
import {Link} from "react-router-dom";
import {ReactComponent as ArrowIcon} from "../../../assets/icons/arrow-right.svg";

export const ServiceRequest = (props) => {
  const {data} = props;
  const {Text} = Typography;
  return (
    <>
      <Col className="rejected-card-container">
        {data?.map((val, idx) => (
          <Col key={idx} className="rejected-card-data-container">
            <Col className="rejected-card-data-sub-container">
              <Col className="rejected-card-data-sub-id-container">
                <Text className="rejected-card-data-sub-id-text">
                  {val?.service_request_id ? val?.service_request_id : "N/A"}
                </Text>
                <Text className="rejected-card-data-sub-name-text">
                  {dateFormat(val?.created_at)}
                </Text>
              </Col>
              <Col className="rfq-requests-card-content-container">
                <Col className="rejected-card-amount-sub-container">
                  <Text className="rejected-card-amount-sub-text">
                    {val?.user_data?.full_name || "N/A"}
                  </Text>
                  <Text className="rejected-card-amount-sub-text-item">
                    {val?.user_data?.phone_number || "N/A"}
                  </Text>
                </Col>
                <Col className="rejected-card-status-container">
                  <Tag
                    style={{
                      fontWeight: 500,
                      fontSize: "14px",
                      padding: "6px 12px",
                    }}
                    className={`tag-font-style ${colorMapping[val?.status]}`}>
                    {val?.status}
                  </Tag>
                  <Link
                    to={`/admin/orders/view-details/${val?.suborder?.id}`}
                    target="_blank">
                    <ArrowIcon style={{color: "blue"}} />
                  </Link>
                </Col>
              </Col>
            </Col>
          </Col>
        ))}
      </Col>
    </>
  );
};
